// removed by extract-text-webpack-plugin
module.exports = {"icon":"back-link__icon___1Sstt","button-back":"back-link__button-back___3D9OM","icon-prev":"back-link__icon-prev___W32uQ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/BackLink/back-link.scss
// module id = 937
// module chunks = 0